import { generatePath, useNavigate } from 'react-router-dom'
import { paths } from 'src/router/paths'
import { UseNoSearchResultsProps } from './useNoSearchResults.types'

const useNoSearchResults = ({ lang, membership }: UseNoSearchResultsProps) => {
  const navigate = useNavigate()

  const enableRedirect = lang && membership

  if (!enableRedirect) {
    return
  }

  const path = generatePath(paths.COMMUNITIES_PATH, {
    lang,
    membership
  })

  return (searchTerm?: string) => navigate(`${path}?q=${searchTerm}`)
}

export default useNoSearchResults
